import React, { useMemo } from 'react';

import { useMediaLikeAndUnLike } from '@entities/media';

export type MediaLikeContextType = {
  likeMediaFile: (streamId: string, mediafileId: string) => Promise<boolean>;
  unLikeMediaFile: (streamId: string, mediafileId: string) => Promise<boolean>;
};

export const MediaLikeContext = React.createContext<MediaLikeContextType>({} as MediaLikeContextType);

export const useMediaLikeContext = () => React.useContext(MediaLikeContext);

const MediaLikeProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const mediaLikeAndUnlike = useMediaLikeAndUnLike();

  const contextValue = useMemo(
    (): MediaLikeContextType => ({
      likeMediaFile: async (streamId: string, mediafileId: string) => {
        const result = await mediaLikeAndUnlike.likeMediaFile(streamId, mediafileId);

        return Boolean(result.data?.result?.ok);
      },
      unLikeMediaFile: async (streamId: string, mediafileId: string) => {
        const result = await mediaLikeAndUnlike.unLikeMediaFile(streamId, mediafileId);

        return Boolean(result.data?.result?.ok);
      },
    }),
    [mediaLikeAndUnlike]
  );

  return <MediaLikeContext.Provider value={contextValue}>{children}</MediaLikeContext.Provider>;
};

export default MediaLikeProvider;
